import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const livingAreaTagManager = createRangeTagManager({
  jsonQueryKey: 'living_area',
  template: 'Жилая площадь %s м²',
  id: 'livingArea',
});
